import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';

const SpotlightCard = ({ service, index }) => {
  const divRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);

  const handleMouseMove = (e) => {
    if (!divRef.current || isFocused) return;
    
    const rect = divRef.current.getBoundingClientRect();
    setPosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleFocus = () => {
    setIsFocused(true);
    setOpacity(1);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setOpacity(0);
  };

  const handleMouseEnter = () => {
    setOpacity(1);
  };

  const handleMouseLeave = () => {
    setOpacity(0);
  };

  return (
    <ScrollReveal key={service.id} delay={index * 0.06} as="li" className="spotlight-wrapper">
      <div 
        ref={divRef}
        onMouseMove={handleMouseMove}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="spotlight-card-container"
      >
        <div 
          className="spotlight-glow"
          style={{
            opacity,
            background: `radial-gradient(600px circle at ${position.x}px ${position.y}px, rgba(197,168,128,0.18), transparent 40%)`
          }}
        />
        
        <Link to={`/service/${service.id}`} className="byhw-service-link spotlight-card-content">
          <div style={{
            display:'flex', alignItems:'center', gap:14, marginBottom:14, width:'100%',
          }}>
            <div style={{
              width:44, height:44, borderRadius:'8px',
              background:'var(--clr-offwhite)', color:'var(--clr-primary)',
              display:'flex', alignItems:'center', justifyContent:'center',
              flexShrink:0,
            }}>
              {service.icon}
            </div>
            <span style={{
              fontWeight: 700, fontSize: '1.05rem',
              color: 'var(--clr-navy)', lineHeight: 1.3,
            }}>{service.title}</span>
          </div>
          <p style={{
            margin: 0, color: 'var(--clr-gray)', fontSize: '0.9rem',
            lineHeight: 1.65, fontWeight: 400, textAlign: 'left',
          }}>{service.desc}</p>
          <span style={{
            marginTop: 'auto', paddingTop: 14,
            display: 'inline-flex', alignItems: 'center', gap: 6,
            color: 'var(--clr-primary)', fontWeight: 600, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.05em'
          }}>Learn More &rarr;</span>
        </Link>
      </div>
    </ScrollReveal>
  );
};

export default SpotlightCard;
